module.exports = __webpack_public_path__ + "static/img/icon_help@2x.6f91da38.png";